import { useEffect, useState } from "react";
import { ContractService } from "../../../../../core/services/ContractService";
import { Singleton } from "../../../../../core/services/Singleton";
import { InputDate } from "../../../../theme/Input/InputDate";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _createProcess } from "../../../../../core/services/dataBean/EntityCatalogVdos";
interface Props {
    IdProcces: any;
    ProccesDate: any
}
export const ReporteProcesosByProcces = ({ IdProcces, ProccesDate }: Props) => {
    const single = Singleton.getInstance();
    const ByProcces = useDataBean(_createProcess);
    const [lista, setLista] = useState<any>([]);
    const [fecha, setFecha] = useState<any>(single.getCurrenDate());

    useEffect(() => {
        getProcessReport();
    }, [IdProcces, ProccesDate])

    const getProcessReport = () => {
        ByProcces.instance.getProcessReport(IdProcces, ProccesDate, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )
    }


    const head = [
        { title: 'ID', property: 'IDProcess', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Usuario logueado', property: 'IDEmployee', visible: true },

    ]

    return (
        <div className="row">

            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={ByProcces.setBean}></BasicTable>
            </div>
        </div>
    )
}